import { toast } from "react-toastify";

import { errMsg } from "../../utils/helperFunction";

import { getPricingApi } from "../../api/pricingApi";

export const getPricing = () => async (dispatch) => {
  try {
    dispatch({
      type: "PRICING_REQ",
    });
    const data = await getPricingApi();

    dispatch({
      type: "PRICING_FETCH_SUC",
      payload: data,
    });
  } catch (err) {
    const message = errMsg(err);

    dispatch({
      type: "PRICING_ERROR",
      payload: {
        error: true,
        message,
      },
    });

    toast.error(message, {
      toastId: message,
      position: "bottom-center",
    });
  }
};
